import type { FilterId } from "../types";
import {
  getRespondentAdvancedFilterId,
  RESPONDENT_ADVANCED_ATTRIBUTES,
} from "./advanced_targeting";
import type { IntegratedPanel } from "@/components/outreach/recruitment/panelPrediction/panelRegistry/panelRegistry";
import { assertNever } from "@/packages/ts-utils";

export const RESPONDENT_FILTER_IDS = {
  country: "respondent.targetCountry" as FilterId,
  cities: "respondent.targetCities" as FilterId,
  genders: "respondent.targetGenders" as FilterId,
  education: "respondent.targetEducation" as FilterId,
  ethnicities: "respondent.targetEthnicities" as FilterId,
  ageGroups: "respondent.targetAgeGroups" as FilterId,
  householdIncome: "respondent.targetHouseholdIncome" as FilterId,
  jobTitles: "respondent.targetJobTitles" as FilterId,
  professionalIndustries: "respondent.targetProfessionalIndustries" as FilterId,
  topics: "respondent.targetProjectTopics" as FilterId,
  seniority: "respondent.seniority" as FilterId,
  companySize: "respondent.targetCompanySize" as FilterId,
  jobFunctions: "respondent.targetJobFunctions" as FilterId,
  audienceSkills: "respondent.targetAudienceSkills" as FilterId,
} as const;

export type RespondentFilterId =
  (typeof RESPONDENT_FILTER_IDS)[keyof typeof RESPONDENT_FILTER_IDS];

export const getRespondentRequiredCategoryFilterId = (
  panel: IntegratedPanel
): FilterId | undefined => {
  switch (panel) {
    case "respondent_b2b":
      return RESPONDENT_FILTER_IDS.professionalIndustries;
    case "respondent_b2c":
      return RESPONDENT_FILTER_IDS.topics;
    case "prolific":
    case "user_interviews":
      return undefined;
    default:
      return assertNever(panel);
  }
};

// Respondent API caps per targeting axis. The picker enforces these
// (Select maxCount) so the saved selection matches what goes on the wire;
// the payload builder keeps them as a backstop for pre-cap rows.
export const RESPONDENT_FILTER_SELECTION_CAPS: Partial<
  Record<FilterId, number>
> = {
  [RESPONDENT_FILTER_IDS.topics]: 2,
  [RESPONDENT_FILTER_IDS.professionalIndustries]: 2,
  [RESPONDENT_FILTER_IDS.jobTitles]: 10,
  [RESPONDENT_FILTER_IDS.audienceSkills]: 25,
  // Undocumented upper bound; staging accepted 60.
  [RESPONDENT_FILTER_IDS.cities]: 50,
  ...Object.fromEntries(
    RESPONDENT_ADVANCED_ATTRIBUTES.filter((a) => a.shape !== "multi").map(
      (a) => [getRespondentAdvancedFilterId(a.key), 1]
    )
  ),
};
